import '../../styles/digitalTraces.css'

function Anticimex() {
    const imageTechnologyUrls = [
        'images/technologies/Figma.png',
        'images/technologies/Supabase.png',
        'images/technologies/PostgreSQL.png',
        'images/technologies/aws.png',
        'images/technologies/React.png',
        'images/technologies/Next.png',
        'images/technologies/typeorm.png'
    ];

    return (
        <div className={'nimber-case-wrapper'}>
            <div>
                <div>
                    <img src={'images/clients/normal/Anticimex.png'} alt={'Anticimex logo'}  style={{ paddingBottom: '32px'}}/>
                    <h1 className={'nimber-main-title-digital'}>Transforming and creating a new platform for Anticimex</h1>
                    <p className={'nimber-texts'}>We solved this seven-headed beast. With an incredible team, fully dedicated, with visionary thinking and creative solutions. Design and development of a new platform for Anticimex Germany with different login profiles (clients, technicians and administrators using data base and CRM connection).</p>
                </div>
                <div>
                    <h3 className={'nimber-sub-section-titles'}>Main Technologies</h3>
                    <div className={'nimber-case-techs'}>
                        {imageTechnologyUrls.map((imageUrl, index) => (
                            <div key={`nimberCaseTechsAx${index}`}>
                                <img key={`Ax${index}`} src={imageUrl} alt={`a ${index}`} className="gallery-image" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Anticimex